import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'

export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  pendingLabel,
  onConfirm,
  onCancel,
  isPending,
  errorMessage,
}: {
  title: string
  children: ReactNode
  confirmLabel: string
  pendingLabel: string
  onConfirm: () => void
  onCancel: () => void
  isPending: boolean
  errorMessage?: string | null
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="mx-4 w-full max-w-sm rounded-[20px] bg-[var(--fl-surface)] p-6 shadow-[rgba(0,0,0,0.15)_0px_8px_40px]"
      >
        <h2 className="mb-2 text-lg font-bold text-[var(--fl-text-1)]">{title}</h2>
        <div className="mb-6 text-sm text-[var(--fl-text-2)]">{children}</div>
        {errorMessage && (
          <p className="-mt-2 mb-4 text-xs text-[var(--fl-error)]">{errorMessage}</p>
        )}
        <div className="flex gap-3">
          <Button variant="outline" onClick={onCancel} className="flex-1">
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
            className="flex-1 font-semibold"
          >
            {isPending ? pendingLabel : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
